module.exports = __webpack_public_path__ + "img/circle-arrow-down-left.65841cb6.svg";